<div class="theme-main-menu sticky-menu theme-menu-five" [ngClass]="headerSticky ? 'fixed' : ''">
  <div class="d-flex align-items-center justify-content-center">
    <div class="logo"><a [routerLink]="['/']"><img src="assets/images/logo/deski_06.svg" alt=""></a></div>

    <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
      <div class="nav-container">
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar"
          [ngClass]="menuActive ? 'navbar-toggler open' : 'navbar-toggler'" (click)="handleNavToggle()">
          <span></span>
        </button>
        <div class="navbar-collapse collapse" id="collapsibleNavbar">
          <div class="d-lg-flex justify-content-between align-items-center">
            <ul class="navbar-nav main-side-nav font-gordita" data-bs-toggle="collapse"
              data-bs-target="#collapsibleNavbar" id="one-page-nav">
              <li class="nav-item dropdown position-static">
                <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Home</a>
                <div class="dropdown-menu">
                  <!-- mega menu start -->
                  <app-mega-menu></app-mega-menu>
                  <!-- mega menu end -->
                </div> <!-- /.dropdown-menu -->
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="feature" class="nav-link" (click)="handleNavToggle()">Features</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="effect" class="nav-link" (click)="handleNavToggle()">Effects</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="template" class="nav-link" (click)="handleNavToggle()">Template</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="feedback" class="nav-link" (click)="handleNavToggle()">Feedback</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div class="right-widget">
      <ul class="d-flex align-items-center">
        <li>
          <a [routerLink]="['/login']" class="signIn-action d-flex align-items-center">
            <img src="assets/images/icon/52.svg" alt="">
            <span>login</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/register']" class="signup-btn"><span>Sign up</span>- It’s Free</a>
        </li>
      </ul>
    </div>
  </div>
</div>